import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';

const formatBoundary = (boundary) => {
    if (boundary) {
        return new Date(boundary);
    }
    return null;
};

// props come from the DataGrid that uses this filter
const DateRangeFilter = (props) => {
    // console.log('props here', props)
    const { item, applyValue } = props;
    const [filterValue, setFilterValue] = useState([null, null]);

    const handleFilterValueChange = (newValue) => {
        applyValue({ ...item, value: newValue });
        setFilterValue(newValue);
    };

    useEffect(() => {
        const { item: { value = [] } } = props;
        let lowerBound = formatBoundary(value[0]);
        let upperBound = formatBoundary(value[1]);
        if (typeof value === 'string') {
            lowerBound = formatBoundary(value.split('-')[0]);
            upperBound = formatBoundary(value.split('-')[1]);
        }
        setFilterValue([lowerBound, upperBound]);
    }, []);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container item components={['SingleInputDateRangeField']} mt={"19px"}>
                <DateRangePicker
                    value={filterValue}
                    onChange={(newValue) => handleFilterValueChange(newValue)}
                    slots={{
                        field: SingleInputDateRangeField,
                        textField: TextField
                    }}
                    slotProps={{
                        textField: {
                            size: 'small',
                            variant: 'standard',
                        }
                    }}
                />
            </Grid>
        </LocalizationProvider>
    );
};

// Get initializer for DateRangeFilter
export const getDateRangeFilterOperator = ({
    label = 'From - To',
    value = 'from-to',
    getApplyFilterFn = () => { }, // this comes from MUI docs, honestly idk what it is used for
    InputComponentProps = {}
}) => {
    return [{
        label,
        value,
        getApplyFilterFn,
        InputComponent: DateRangeFilter,
        InputComponentProps
    }];
};

export default getDateRangeFilterOperator;
